import React from 'react';

export default function SVGDot(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="none"
      className="text-iconStrong fill-current"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
